import { Globals } from './../global';
import { GameService } from './game.service';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders, HttpRequest, HttpResponse, HttpHandler, HttpEvent, HttpInterceptor, HTTP_INTERCEPTORS } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from "src/environments/environment";

@Injectable({
  providedIn: 'root'
})
export class DecryptService {

  public baseUrl: string = `${environment.decript}`;

  constructor(
    private http: HttpClient,
    public global: Globals
  ) { }

  doDecrypt(token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'token': token,
        'Access-Control-Allow-Origin': '*'
      })
    };

    const body = {};

    // return this.http.post(this.baseUrl + '/decrypt.php', body, httpOptions);
    return this.http.post(this.baseUrl + 'api/decrypt.php', body, httpOptions);
  }

  decrypt(msisdnEnc: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      })
    };

    const body = {
      serviceId: 0,
      data: msisdnEnc,
      operatorId: 253
    };

    return this.http.post(this.global.baseUrlSimple + 'decrypt', body, httpOptions);
  }

  ok(body?) {
    return of(new HttpResponse({ status: 200, body }))
  }
}
